import { useEffect, useState } from 'react';
import api from '../../lib/api';

export default function PayoutTab(){
  const [bal, setBal] = useState(null);
  const [amt, setAmt] = useState('');
  const [status, setStatus] = useState('');
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{ 
    loadBalance();
    loadHistory();
  }, []);

  const loadBalance = async () => {
    try {
      const response = await api.get('/landlord/balance');
      setBal(response.data);
    } catch (err) {
      console.error('Failed to load balance:', err);
    }
  };

  const loadHistory = async () => {
    try {
      const response = await api.get('/landlord/payouts/history');
      setHistory(response.data.payouts || []);
    } catch (err) {
      console.error('Failed to load history:', err);
    }
  };

  const submit = async()=>{
    setStatus('');
    setLoading(true);
    try {
      const response = await api.post('/landlord/payout/request', { 
        amount_cents: Math.round(Number(amt)*100), 
        country:'BS', 
        currency:'USD', 
        priority:'standard' 
      });
      setStatus('Payout requested successfully!');
      setAmt('');
      await loadBalance();
      await loadHistory();
    } catch (err) {
      setStatus('Error: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 space-y-4">
      <div className="border rounded p-3">
        <div className="text-sm text-gray-600">Available Balance</div>
        <div className="text-2xl font-bold">${((bal?.balance_cents||0)/100).toFixed(2)}</div>
      </div>
      <div className="flex items-center gap-2">
        <input 
          className="border rounded px-3 py-2" 
          placeholder="Amount (USD)" 
          value={amt} 
          onChange={e=>setAmt(e.target.value)}
          disabled={loading}
        />
        <button 
          onClick={submit} 
          className="px-4 py-2 rounded bg-black text-white disabled:opacity-50"
          disabled={loading || !amt}
        >
          {loading ? 'Processing...' : 'Request Payout'}
        </button>
      </div>
      {status && <div className={`text-sm ${status.includes('Error') ? 'text-red-600' : 'text-green-600'}`}>{status}</div>}
      
      <div className="mt-6">
        <h3 className="font-semibold mb-3">Payout History</h3>
        <div className="border rounded">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-3 text-sm">Date</th>
                <th className="text-left p-3 text-sm">Amount</th>
                <th className="text-left p-3 text-sm">Fee</th>
                <th className="text-left p-3 text-sm">Net</th>
                <th className="text-left p-3 text-sm">Method</th>
                <th className="text-left p-3 text-sm">Status</th>
              </tr>
            </thead>
            <tbody>
              {history.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center p-4 text-gray-500">No payouts yet</td>
                </tr>
              ) : (
                history.map((payout) => (
                  <tr key={payout.id} className="border-t">
                    <td className="p-3 text-sm">{new Date(payout.requested_at).toLocaleDateString()}</td>
                    <td className="p-3 text-sm">${(payout.requested_amount_cents/100).toFixed(2)}</td>
                    <td className="p-3 text-sm">${(payout.fee_total_cents/100).toFixed(2)}</td>
                    <td className="p-3 text-sm">${(payout.settled_amount_cents/100).toFixed(2)}</td>
                    <td className="p-3 text-sm capitalize">{payout.method || '-'}</td>
                    <td className="p-3 text-sm">
                      <span className={`px-2 py-1 rounded text-xs ${
                        payout.status === 'completed' ? 'bg-green-100 text-green-800' :
                        payout.status === 'failed' ? 'bg-red-100 text-red-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {payout.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
